<template>
  <v-container fluid class="container-links">
    <BrAppBar>
      <div class="py-3 title d-none d-sm-block page-title">
        {{ $t('links.title') }}
      </div>
    </BrAppBar>

     <div class="title d-sm-none page-title">
      {{ $t('links.title') }}
    </div>
    
    <!-- <v-row v-if="isAffiliate"> -->
      <!-- <v-col cols="12" md="6">
        <v-hover>
          <template v-slot="{ hover }">
            <v-card outlined :class="`elevation-${hover ? 6 : 3}`">
              <div class="d-flex justify-space-between align-center px-5 py-3">
                <div class="sub-title">
                  Seu URL De btag
                </div>
                <div class="text-end">
                  Cliques mensais: 0
                </div>
              </div>

              <v-divider></v-divider>

              <div class="d-flex justify-space-between align-center pa-3">
                <div class="rounded-pill py-2 px-4 flex-grow-1 ms-5 me-3"
                  style="border: 2px solid #CCC; color: #7C7C8A"> {{ refLink }}
                </div>
                <div class="d-flex justify-end me-2">
                  <v-btn @click="copyToClipboard(refLink)" color="blue" class="rounded-pill" style="color: white;">
                    <v-icon>mdi-content-copy</v-icon> Copiar Link</v-btn>
                </div>
                <v-btn class="rounded-pill" style="color: white;" :color="variables.colorSecondary"
                  @click="openModalQrCode(refLink)">
                  <v-icon>mdi-qrcode-scan</v-icon>
                  QrCode
                </v-btn>
              </div>
            </v-card>
          </template>
        </v-hover>
      </v-col> -->
      <!-- <v-col cols="12" md="6">
        <v-hover>
          <template v-slot="{ hover }">
            <v-card rounded="xl" outlined :class="`elevation-${hover ? 6 : 3}`">
              <div class="d-flex align-center px-5 py-3">
                <div class="me-2 sub-title">
                  Seu URL De Referência
                </div>
                <v-icon class="sub-title-icon">mdi-information-outline</v-icon>
              </div>

              <v-divider></v-divider>

              <div class="d-flex justify-space-between align-center pa-3">
                <div class="rounded-pill py-2 px-4 flex-grow-1 ms-5 me-3" style="border: 2px solid #CCC;color:#7C7C8A;">
                  {{
      subUserLink }} </div>
                <div class="d-flex justify-end me-2">
                  <v-btn @click="copyToClipboard(subUserLink)" color="blue" class="rounded-pill" style="color: white;">
                    <v-icon>mdi-content-copy</v-icon> Copiar Link</v-btn>
                </div>
                <v-btn class="rounded-pill" style="color: white;" :color="variables.colorSecondary"
                  @click="openModalQrCode(subUserLink)">
                  <v-icon>mdi-qrcode-scan</v-icon>
                  QrCode
                </v-btn>

              </div>
            </v-card>
          </template>
        </v-hover>
      </v-col>
    </v-row> -->

    <v-row>
      <v-col cols="12">
        <v-card elevation="3" outlined class="flex-grow-1 card-table">
          <div class="card-section-header">
            {{ $t('links.title') }}
          </div>
          <div class="px-4 py-3">
            <v-skeleton-loader :transition="'fade-transition'" height="500" type="table">
              <v-data-table dark :headers="headers" :items="listaItens" hide-default-footer :mobile-breakpoint="0"
                :items-per-page="this.$store.getters.ItensPaginacao" class="table-operator" :loading="loadingTable">
                <template v-slot:top>
                  <v-row justify="space-between" class="px-3 mb-2 top-table" align="center">
                    <v-col cols="12" sm="6" md="4" class="pa-2">
                      <v-text-field
                        hide-details="auto"
                        dense
                        outlined
                        prepend-inner-icon="mdi-magnify"
                        placeholder="Buscar"
                        class="search-button"
                        v-model="searchText"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="pa-2 text-sm-right" v-if="permiteAcao($route, 'add') && isAffiliate">
                      <v-btn depressed class="action-criar-link" @click="openModalCriarLink">
                        <v-icon small left>mdi-plus</v-icon>
                        {{ $t('links.criarLinkDestino') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </template>

                <template v-slot:item.actions="{ item }">
                  <div class="link-actions">
                    <v-btn depressed class="action-copiar" :disabled="item.copyLoading"
                      @click="copyLink(item.urlMasked, item)">
                      <template v-if="item.copyLoading">
                        <v-progress-circular indeterminate size="16" width="2"></v-progress-circular>
                        <span class="ml-2">{{ $t('links.gerando') }}</span>
                      </template>
                      <template v-else-if="item.copySuccess">
                        <v-icon small left>mdi-check</v-icon>
                        {{ $t('links.gerado') }}
                      </template>
                      <template v-else>
                        {{ (item.urlMasked || item.campaingLink) ? $t('links.copiarLink') : $t('links.gerarLink') }}
                      </template>
                    </v-btn>

                    <v-btn icon class="action-icon" :loading="item.editLoading"
                      :title="$t('links.personalizar')"
                      @click="openModalPersonalizar(item)"
                      v-if="permiteAcao({ path: '/afiliados/links/view/' }, '') || permiteAcao($route, 'edit')">
                      <v-icon small>mdi-tune-variant</v-icon>
                    </v-btn>

                    <v-btn icon class="action-icon" :loading="item.qrCodeLoading"
                      :title="$t('links.escaneieQrCode')"
                      @click="handleQrCodeClick(item)">
                      <img src="~@/assets/img/qr_code.svg" alt="">
                    </v-btn>
                  </div>
                </template>

                <template v-slot:item.name="{ item }">
                  <div class="name-column">{{ item.name }}</div>
                  <div class="name-subtitle" v-if="item.campaigntypeName">{{ item.campaigntypeName }}</div>
                </template>

                <template v-slot:item.brand="{ item }">
                  <span class="brand-name">{{ brand.name }}</span>
                  <span class="brand-id">#{{ linkIdOf(item) }}</span>
                </template>

                <template v-slot:footer>
                  <div class="wrapper-footer">
                    <div class="qtd-paginacao">
                      <!-- <v-icon small class="mr-2" color="#7C7C8A">mdi-text-box-outline</v-icon> -->
                      <span class="paginacao-text">
                        Exibindo 
                        <span class="paginacao-number">{{ pageStart }}</span>
                        -
                        <span class="paginacao-number">{{ pageStop }}</span>
                        de
                        <span class="paginacao-number">{{ totalItens }}</span>
                        {{ totalItens === 1 ? 'registro' : 'registros' }}
                      </span>
                    </div>
                    <v-pagination 
                      v-model="page" 
                      :length="numberOfPages" 
                      circle 
                      :disabled="disabled" 
                      :total-visible="7"
                      class="box-table-paginacao" 
                      v-if="numberOfPages > 1"
                    ></v-pagination>
                  </div>
                </template>

              </v-data-table>
            </v-skeleton-loader>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <!-- Dialogs: ModalCadastro (Personalizar) é aberta pelo botão de personalizar da tabela -->
    <ModalCadastro />
    <ModalQrCode />
    <ModalCriarLink />
  </v-container>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { errorSnackbar, successSnackbar } from '@/core/service/utils'
import { mapActions, mapGetters } from 'vuex'
import listagemTables from '@/views/mixins/listagemTables'
import Events from '@/core/service/events'
import brand from '@/core/brand'

export default {
  name: 'Links',
  mixins: [listagemTables],
  components: {
    ModalCadastro: () => import('./components/modalCadastro'),
    ModalQrCode: () => import('./components/modalQrCode'),
    ModalCriarLink: () => import('./components/modalCriarLink'),
    BrAppBar: () => import('@/views/layout/appBar'),
  },
  data: () => ({
    searchText: null,
  }),
  computed: {
    ...mapGetters('links', ['listaItens', 'totalItens', 'urlPlataforma']),
    ...mapGetters('auth', ['user']),
    ...mapGetters('roles', ['permiteAcao']),
    brand: () => brand,

    headers() {
      return [
        { align: 'start', class: 'table-header', text: this.$t('links.headers.acoes'), value: 'actions', width: '260px', sortable: false },
        { align: 'start', class: 'table-header', text: this.$t('links.headers.nomeDoLink'), value: 'name' },
        { align: 'start', class: 'table-header', text: this.$t('links.headers.marcaId'), value: 'brand', width: '200px', sortable: false },
      ]
    },

    isAffiliate() {
      if (!this.user.jsonFlags) return false
      return this.user.jsonFlags.affiliateId
    },

    refLink() {
      if (!this.user.jsonFlags) return ''
      return `${this.urlPlataforma}/?btag=${this.user.jsonFlags.affiliateId}`
    },

    subUserLink() {
      if (!this.user.jsonFlags) return ''
      return `${this.urlPlataforma}?referralId=${this.user.jsonFlags.affiliateId}`
    }
  },
  mounted() {
    Events.$on('links::listaItens', () => {
      this.init()
    })
  },
  watch: {
    searchText () {
      clearTimeout(this.debounce)
      const vm = this
      this.debounce = setTimeout(() => {
        if (vm.searchText === null || vm.searchText.length === 0) {
          vm.buscar('')
          return
        }

        vm.buscar(vm.searchText)
      }, 600)
    }
  },
  methods: {
    ...mapActions('links', ['getItens', 'getItem', 'limparItems', 'editSmarticoLink']),

    // #ID exibido é o id do link na Smartico, que é a identidade do link para o afiliado
    linkIdOf(item) {
      return item.config?.link_id || String(item.id).replace('smartico_', '')
    },

    copyToClipboard(link) {
      navigator.clipboard.writeText(link)
      successSnackbar(this.$t('links.linkCopiado'))
    },

    // Loading é por linha (item), não do componente: um flag compartilhado colocava todas as
    // linhas da tabela em loading ao clicar em uma só
    openModalPersonalizar(item) {
      this.$set(item, 'editLoading', true)
      this.getItem({ campaignId: item.id })
        .then(() => {
          // a modal lê url/tag do item carregado no store para montar o preview do link
          Events.$emit('links::openModalPersonalizar')
        })
        .catch(e => { errorSnackbar(e.error) })
        .finally(() => { this.$set(item, 'editLoading', false) })
    },
    
    async handleQrCodeClick(item) {
      console.log('🖱️ [FRONTEND] Clicou no QR Code')
      
      // Se for link Smartico, precisa gerar primeiro
      if (item.isSmartico) {
        this.$set(item, 'qrCodeLoading', true)
        console.log('🔧 [FRONTEND] Link Smartico - gerando URL primeiro')
        
        try {
          const linkId = item.id.replace('smartico_', '')
          const response = await this.editSmarticoLink({
            linkId: parseInt(linkId),
            utm_source: item.config?.utm_source || '',
            utm_medium: item.config?.utm_medium || '',
            utm_campaign: item.config?.utm_campaign || '',
            utm_term: item.config?.utm_term || '',
            utm_content: item.config?.utm_content || ''
          })
          
          if (response.data.success && response.data.url) {
            console.log('✅ [FRONTEND] Link Smartico gerado:', response.data.url)
            this.openModalQrCode(response.data.url)
          } else {
            errorSnackbar('Erro ao gerar link para QR Code')
          }
        } catch (err) {
          console.log('❌ [FRONTEND] Erro ao gerar link Smartico:', err)
          errorSnackbar(err.error || 'Erro ao gerar QR Code')
        } finally {
          this.$set(item, 'qrCodeLoading', false)
        }
      } else {
        // Link tradicional - abre direto
        this.openModalQrCode(item.campaingLink)
      }
    },
    
    openModalQrCode(url) {
      Events.$emit('links::openModalQrCode', url)
    },

    openModalCriarLink() {
      Events.$emit('links::openModalCriarLink')
    },
    // A lista vem do catálogo da Smartico, então a busca é por `search` (filtrada na BFF por nome).
    // O filtro `_addlFilter` de antes só afetava a query de campanhas no micro-api e não a lista exibida.
    buscar(val) {
      this.limparItems()
      this.loadingTable = true
      this.objCampoBusca['search'] = val || undefined
      this.getItens({ search: val || undefined })
        .then(result => {
          if (result.data.totalItens < 1) {
            errorSnackbar(this.$t('links.semDados'))
          }
        })
        .catch(err => {
          errorSnackbar(err.error)
        })
        .finally(() => { this.loadingTable = false })
    },

    async copyLink(link, item) {
      try {
        console.log('🖱️ [FRONTEND] Usuário clicou em Gerar Link')
        console.log('📋 [FRONTEND] Dados do item:', { 
          id: item.id, 
          name: item.name, 
          isSmartico: item.isSmartico, 
          currentLink: link 
        })
        
        // Estados de loading/sucesso para o botão
        this.$set(item, 'copyLoading', true)
        this.$set(item, 'copySuccess', false)

        // Se é um link Smartico e não tem URL gerada, gerar primeiro
        if (item.isSmartico && (!link || link === null)) {
          console.log('🔧 [FRONTEND] Link Smartico sem URL, gerando...')
          const linkId = item.id.replace('smartico_', '') // Remove prefixo smartico_
          console.log('🆔 [FRONTEND] Link ID extraído:', linkId)
          
          console.log('📡 [FRONTEND] Chamando backend para gerar link...')
          const response = await this.$store.dispatch('links/generateSmarticoLink', {
            linkId: parseInt(linkId)
          })
          
          console.log('📨 [FRONTEND] Resposta do backend:', response.data)
          
          if (response.data.success) {
            // Usar URL final concatenada
            link = response.data.url
            console.log('✅ [FRONTEND] URL final gerada:', link)
            
            // Atualizar o item com os dados gerados (config vem do que foi persistido)
            this.$set(item, 'campaingLink', response.data.url)
            this.$set(item, 'urlMasked', response.data.url)
            if (response.data.config) this.$set(item, 'config', response.data.config)
            console.log('🔄 [FRONTEND] Item atualizado com novos dados')
          } else {
            console.log('❌ [FRONTEND] Erro na geração do link')
            throw new Error('Erro ao gerar link')
          }
        } else {
          console.log('✅ [FRONTEND] Link já existe, usando:', link)
        }
        
        // Copiar para clipboard APÓS ter a URL
        console.log('📋 [FRONTEND] Copiando para clipboard:', link)
        await navigator.clipboard.writeText(link)
        
        // Feedback visual de sucesso
        this.$set(item, 'copySuccess', true)
        setTimeout(() => {
          this.$set(item, 'copySuccess', false)
        }, 1500)
        console.log('🎉 [FRONTEND] Link copiado com sucesso!')
      } catch (error) {
        console.log('💥 [FRONTEND] Erro ao copiar link:', error)
        this.$set(item, 'copySuccess', false)
        // Aqui você pode adicionar uma notificação de erro se quiser
      } finally {
        this.$set(item, 'copyLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/components/table';


i {
  color: #FFFF !important; 
}

.row {
  /* flex-wrap: nowrap !important;
  align-items: center; */
  margin-top: 10px;
}

.v-application .top-table {
  align-items: center;
  
  @media (max-width: 600px) {
    .v-col {
      padding: 8px 12px !important;
    }
  }
  
  @media (max-width: 485px) {
    display: flex;
    flex-direction: column !important;
    justify-content: center !important;
    
    .v-col {
      width: 100% !important;
      max-width: 100% !important;
      flex: 1 1 100% !important;
    }
  }
}

.v-data-table::v-deep thead tr th,
.v-data-table::v-deep .v-data-table-header th.sortable .v-data-table-header__icon {
  color: #7C7C8A !important;
}

.v-data-table::v-deep {
  .v-data-table-header {
    background: #0D0F1D;
  }
}


  .title {
    color: #FFFF;
  }

  // Barra de destaque à esquerda do título, na cor da marca ativa
  .page-title {
    display: flex;
    align-items: center;
    gap: 12px;

    &::before {
      content: '';
      width: 3px;
      height: 22px;
      border-radius: 2px;
      background: var(--v-primary-base);
    }
  }

  // Cabeçalho da seção com régua de destaque abaixo
  .card-section-header {
    padding: 20px 24px 16px;
    font-size: 16px;
    font-weight: 500;
    color: #FFF;
    border-bottom: 2px solid var(--v-primary-base);
  }

  .search-button {
    border-radius: 8px;
    width: 100%;
    
    @media (max-width: 600px) {
      max-width: 100%;
    }
  }

    .sub-title {
    color: #7C7C8A;
  }

  .text-end {
    color: #7C7C8A;
  }

   .search-button {
    @media (max-width: 485px) {
      width: 370px !important;
    }
  }


.box-table::v-deep {
 

  .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    margin-top: 20px;
    margin-bottom: 30px;
  }



  .v-data-table thead tr th,
  .v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
    color: $colorPrimary !important;
  }

  .v-data-table-header-mobile {
    display: none;
  }


  .v-data-table>.v-data-table__wrapper>table>thead>tr>th:first-child {
    border-top-left-radius: 8px !important;
    border-bottom-left-radius: 8px !important;
  }

  .v-data-table>.v-data-table__wrapper>table>thead>tr>th:last-child {
    border-top-right-radius: 8px !important;
    border-bottom-right-radius: 8px !important;
  }

  .theme--light.v-input input,
  .theme--light.v-input textarea,
  .theme--light.v-input input,
  .theme--light.v-input .i .theme--light.v-input input,
  .v-application .primary--text,
  .theme--light.v-input ::placeholder {
    color: #7C7C8A !important;
  }

  .v-text-field {
    border-radius: 8px;
  }

  .v-text-field--outlined {

    input::placeholder {
      color: #7C7C8A !important;

      i {
        color: #7C7C8A !important;
      }
    }

    input {
      color: #7C7C8A !important;
    }

    i {
      color: #7C7C8A !important;
    }

    /* .v-label {
      top: 50%;
      transform: translateY(-50%);
      font-size: 0.75em;
    } */

    /* .v-label--active {
      transform: translateY(-25px) scale(0.75);
    } */

    fieldset {
      border-radius: 8px;
      border-color: #7C7C8A !important;
      border-width: 1px;
    }

    i {
      color: #7C7C8A !important;
    }
  }





  i.v-icon.notranslate.sub-title-icon.mdi.mdi-information-outline.theme--light {
    color: #7C7C8A !important;
  }
}


  .link-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 0;
  }

  // Cor vem do tema Vuetify, que é montado a partir de src/core/brand (as variáveis SCSS não são
  // brand-aware e fixariam a paleta da Tradicional em todas as marcas)
  .action-copiar {
    background: var(--v-primary-base) !important;
    color: #FFF !important;
    border-radius: 8px;
    min-width: 132px;
    height: 38px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: none;

    &::v-deep .v-icon {
      color: #FFF !important;
    }
  }

  .action-criar-link {
    background: var(--v-primary-base) !important;
    color: #FFF !important;
    border-radius: 8px;
    height: 38px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: none;

    &::v-deep .v-icon {
      color: #FFF !important;
    }
  }

  .action-icon {
    width: 38px;
    height: 38px;
    border-radius: 8px;
    background: #373749;

    &:hover {
      background: #4A4A5E;
    }

    &::v-deep .v-icon {
      color: #FFF !important;
    }

    // qr_code.svg tem fill escuro fixo (#1D1D29, herdado de quando o botão era claro) e é
    // carregado como <img>, então a cor não é alcançável por CSS: o filtro força o glifo a branco
    img {
      width: 18px;
      height: 18px;
      filter: brightness(0) invert(1);
    }
  }

  .name-column {
    color: #FFF !important;
    font-weight: 600;
    font-size: 14px;
  }

  .name-subtitle {
    color: #7C7C8A !important;
    font-weight: 400;
    font-size: 13px;
  }

  .brand-name {
    color: #E4E4E7 !important;
    font-weight: 500;
    font-size: 14px;
  }

  .brand-id {
    color: #6B7280 !important;
    font-weight: 400;
    font-size: 13px;
    margin-left: 8px;
  }

  .wrapper-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 16px;
    background-color: #1D1D29;
    border-top: 1px solid rgba(124, 124, 138, 0.2);
    
    @media (max-width: 768px) {
      flex-direction: column;
      gap: 16px;
      padding: 16px;
    }
  }

  .qtd-paginacao {
    position: relative;
    display: flex;
    align-items: center;
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px solid var(--v-primary-base);
    overflow: hidden;

    // Fundo tingido com a cor da marca: --v-primary-base é um hex, então o alpha vem de uma
    // camada com opacity em vez de rgba() (que não aceita custom property como componente)
    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: var(--v-primary-base);
      opacity: 0.12;
      pointer-events: none;
    }

    .paginacao-text {
      position: relative;
      color: #A1A1AA;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0.3px;
    }

    .paginacao-number {
      position: relative;
      color: var(--v-primary-base);
      font-weight: 700;
      font-size: 15px;
      margin: 0 4px;
    }
  }

  .box-table-paginacao::v-deep {
    .v-pagination__item {
      background-color: #373749 !important;
      color: #FFF !important;
      border: 1px solid rgba(124, 124, 138, 0.3);
      min-width: 36px;
      height: 36px;
      
      &:hover {
        background-color: #4a4a5e !important;
      }
      
      &--active {
        background-color: var(--v-primary-base) !important;
        border-color: var(--v-primary-base) !important;
        color: #FFF !important;
      }
    }
    
    .v-pagination__navigation {
      background-color: #373749 !important;
      color: #7C7C8A !important;
      border: 1px solid rgba(124, 124, 138, 0.3);
      
      &:hover {
        background-color: #4a4a5e !important;
      }
      
      &--disabled {
        opacity: 0.3;
      }
    }
  }

.v-application .top-table {
  margin-bottom: 20px !important;
}

.theme--dark.v-data-table {
  background: #1D1D29 !important;
  // border-radius: 16px;
}

.container-links::v-deep {
  .theme--light.v-card {
    background: #1D1D29 !important;
    border-radius: 16px;
  }

  .card-table {
    background: #1D1D29;
    border-radius: 16px;
  }

  .theme--light.v-data-table {
    padding-top: 20px !important;
  }
  
  // Hover na tabela de links destino (light e dark). Cinza neutro elevado: o tom anterior era
  // avermelhado e brigava com a cor da marca ativa
  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper),
  .theme--dark.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: #252533 !important;
  }
  
  // Garantir que a última linha do tbody não tenha hover permanente quando não for Total (sem th na primeira célula)
  .v-data-table .v-data-table__wrapper table tbody tr:last-child:not(:has(th:first-child)) {
    &:not(:hover) {
      background-color: transparent !important;
    }
  }
}

</style>
